import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AppState } from '../../../state/appState';
import { Observable, Subscription } from 'rxjs';
import { CashcutListPaginationModel } from '../../../state/appState.model';
import {
  StartLoading,
  StopLoading,
} from '../../../state/actions/general.actions';
import { RouteCashcutDetails } from '../../../state/actions/routing.actions';
import { catchError, mergeMap } from 'rxjs/operators';
import { GetMoreCashcutListItems } from '../../../state/actions/merchant.actions';
import { CashcutListItemModel } from '../../../shared/models/cashcutListItem.model';

@Component({
  selector: 'app-cashcut-list',
  templateUrl: './cashcut-list.component.html',
  styleUrls: ['./cashcut-list.component.scss'],
})
export class CashcutListComponent implements OnInit, OnDestroy {
  @Select(AppState.cashcutList$)
  cashcutList$: Observable<CashcutListPaginationModel>;

  private subscriptions: Subscription[] = [];

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(new StartLoading());

    this.subscriptions.push(
      this.cashcutList$.subscribe((t) => {
        this.store.dispatch(new StopLoading());
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onShowCashcutDetails(c: CashcutListItemModel): void {
    this.store.dispatch(new RouteCashcutDetails(c.id));
  }

  loadMore(): void {
    console.log('load more cashcuts...');
    this.store
      .dispatch(new StartLoading())
      .pipe(
        mergeMap(() => this.store.dispatch(new GetMoreCashcutListItems())),
        catchError(() => this.store.dispatch(new StopLoading()))
      )
      .subscribe();
  }
}
